// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"100":"9e181354","127":"52a27f9c","315":"eb3d0558"}[chunkId] + ".css";
};